import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { InviteScreen } from '../auth/InviteScreen';
import { HideScrollBarOnWeb } from '../components/HideScrollBarOnWeb';
import Theme from '../theme';
import { clearDeepLinkParams } from '../utils/notifications/actions';
import { defaultScale } from '../utils/scaling';
interface IProps {
  navigation: any;
  influencerName: string;
  influencerId: string;
  avatar: string | null;
  landingPage: string | undefined;
  personalisedHeader: string | undefined;
  t(key: string, options?: any): string;
  clearDeepLinkParamsForInfluencerId(): void;
}
class InfluencerInviteScreenComponent extends PureComponent<IProps> {

  public componentDidMount(): void {
    this.props.clearDeepLinkParamsForInfluencerId();
  }
  public renderInviteText = () => {
    const { t, influencerName, personalisedHeader } = this.props;
    return (
      <View style={styles.inviteTextContainer}>
        <Text style={styles.subHeader}>
          {t('joinFriendForWorkout', {
            referredByFullname: influencerName,
            personalisedHeader: personalisedHeader || 'Fitillion',
          })}
        </Text>
        <Text style={styles.subText}>
          {t('bookings:lookOutForInfluencerWorkouts', {influencer: influencerName})}
        </Text>
      </View>
    );
  }
  public render() {
    const { t, navigation, avatar, landingPage, personalisedHeader } = this.props;
    const inviterImageSource = avatar ? { uri: `data:image/png;base64,${avatar}` } : null;
    return (
          <HideScrollBarOnWeb className='influencer-container'>
            <InviteScreen
              navigation={navigation}
              renderInviteText={this.renderInviteText}
              t={t}
              renderFixedContent={this.renderInviteText}
              inviterImageSource={inviterImageSource}
              landingPage={landingPage}
            />
          </HideScrollBarOnWeb>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearDeepLinkParamsForInfluencerId: () =>
      dispatch(clearDeepLinkParams(['influencerId'])),
  };
};

const styles = StyleSheet.create({
  inviteTextContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  subHeader: {
    ...Theme.textStyle.heading,
    textAlign: 'center',
  },
  subText: {
    ...Theme.textStyle.bodyCopyReg,
    marginVertical: defaultScale(12),
    maxWidth: '90%',
    textAlign: 'center',
  },
});

export const InfluencerInviteScreen = translate(['auth', 'formFields'], {
  wait: true,
})(connect(null,mapDispatchToProps)(InfluencerInviteScreenComponent));
